import { render, staticRenderFns } from "./adminRoomDetail.vue?vue&type=template&id=e967a816&scoped=true"
import script from "./adminRoomDetail.vue?vue&type=script&lang=js"
export * from "./adminRoomDetail.vue?vue&type=script&lang=js"
import style0 from "./adminRoomDetail.vue?vue&type=style&index=0&id=e967a816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e967a816",
  null
  
)

export default component.exports